// export const BASE_URL = 'https://meatravel-backend.onrender.com/api/v1'
export const BASE_URL = 'https://api.mea-travel.com/api/v1'
// export const BASE_URL = 'https://mea-travel.com/backend/api/v1'
// export const BASE_URL = 'http://localhost:4000/api/v1'
